export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LANG = 'LANG';
export const SEARCH = 'SEARCH';
export const LOGINMODAL = 'LOGINMODAL';
export const ISSIGNIN = 'ISSIGNIN';
export const ISDEVELOPERLOGIN = 'ISDEVELOPERLOGIN'


export const TEMPLATEPACKAGEIDMODAL = 'TEMPLATEPACKAGEIDMODAL'